export default __webpack_public_path__ + "static/media/p7-home.e424ce9d.png";